import AiFieldHintWrapper from 'components/AiFieldHintWrapper';
import { isEqual } from 'lodash';
import React from 'react';
import {
  Control,
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
} from 'react-hook-form';
import { useAiFormFill } from './AiFormFillContext';
import { FormValues } from './FormWrapper';

type RenderArgs<TName extends keyof FormValues> = {
  field: ControllerRenderProps<FormValues, TName>;
  fieldState: ControllerFieldState;
};

type Props<TName extends keyof FormValues> = {
  name: TName;
  control: Control<FormValues>;
  render: (args: RenderArgs<TName>) => React.ReactNode;
};

const AiFieldHintController = <TName extends keyof FormValues>({
  name,
  control,
  render,
}: Props<TName>) => {
  const { hints, originalValues, revertField } = useAiFormFill();
  const hint = hints[name];
  const hasOriginal = name in originalValues;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const isModified =
          hasOriginal && !isEqual(field.value, originalValues[name]);
        return (
          <AiFieldHintWrapper
            confidence={hint?.confidence}
            reason={hint?.reason}
            isModified={isModified}
            onRevert={hasOriginal ? () => revertField(name) : undefined}
          >
            {render({ field, fieldState })}
          </AiFieldHintWrapper>
        );
      }}
    />
  );
};

export default AiFieldHintController;
